import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import Routes from 'routes';
import themes from 'themes';
import NavigationScroll from 'layout/NavigationScroll';
import {useSelector} from "react-redux";

// project imports
import useToken from './hooks/useToken';
import {isTokenExpired} from './helpers/data-helper.js';
import config from './config';
import {
    getRedirectUrl,
    isLocalLoginRoute,
} from './helpers/string-helper.js';

const App = () => {
    const customization = useSelector((state) => state.customization);
    const { token } = useToken();

  if ((!token || (token && isTokenExpired(token))) && !isLocalLoginRoute()) {
    window.location.href = getRedirectUrl(config.domain);
    return null;
  }

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;